<template>
	<v-container grid-list-md class="container--box">
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-card>
				<v-card-title primary-title>
					{{ $t("title.checkout") }}
				</v-card-title>
				<v-card-subtitle>
					<v-alert
						dismissible
						color="secondary"
						border="left"
						elevation="2"
						colored-border
						icon="mdi-cash"
						v-if="item.hash"
					>
						<v-row align="center">
							<v-col class="grow">
								If you are already paid, please click verify
								button to continue.
							</v-col>
							<v-col class="shrink" @click="verifyPayment()">
								<v-btn :loading="$wait.is('verifying payment')">
									{{ $t("label.verify") }}
								</v-btn>
							</v-col>
						</v-row>
					</v-alert>
				</v-card-subtitle>
				<v-card-text>
					<v-layout row wrap>
						<v-flex xs12 md9 class="pr-10">
							<v-layout row wrap>
								<v-flex xs12>
									<CheckoutAddressForm
										v-model="item"
										:addresses="addresses"
									></CheckoutAddressForm>
								</v-flex>
								<v-flex xs12 v-if="vouchers.length">
									<CheckoutVoucherForm
										v-model="item"
										:vouchers="vouchers"
									></CheckoutVoucherForm>
								</v-flex>
								<v-flex xs12>
									<CheckoutPaymentMethodForm
										v-model="item"
										:payment_methods="payment_methods"
									></CheckoutPaymentMethodForm>
								</v-flex>
								<v-flex xs12>
									<v-card flat>
										<v-card-title primary-title>
											{{ $t("Description") }}
										</v-card-title>
										<v-card-text>
											<v-textarea
												v-model="item.description"
												filled
											></v-textarea>
										</v-card-text>
									</v-card>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md3>
							<v-card
								:loading="
									$wait.is('applying voucher') ||
									$wait.is('removing voucher')
								"
								loader-height="10"
							>
								<v-card-title primary-title>
									{{ $t("title.order_summary") }}
								</v-card-title>
								<v-card-text>
									<v-layout row wrap>
										<v-flex xs12>
											<v-list dense>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
															$t("label.initial")
														}}</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action-text>{{
														cart_data.initial
													}}</v-list-item-action-text>
												</v-list-item>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
															$t("Discount")
														}}</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action-text>{{
														cart_data.discount
													}}</v-list-item-action-text>
												</v-list-item>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
															$t("Subtotal")
														}}</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action-text>{{
														cart_data.subtotal
													}}</v-list-item-action-text>
												</v-list-item>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
															$t("label.tax")
														}}</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action-text>{{
														cart_data.tax
													}}</v-list-item-action-text>
												</v-list-item>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
															$t("Total")
														}}</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action-text>{{
														cart_data.total
													}}</v-list-item-action-text>
												</v-list-item>
											</v-list>
										</v-flex>

										<v-flex xs12>
											<v-btn
												color="primary"
												block
												:disabled="invalid"
												@click="submit"
												:loading="item.processing"
												>{{
													$t("label.place_an_order")
												}}</v-btn
											>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</ValidationObserver>

		<v-dialog v-model="dialog" persistent max-width="800px" attach>
			<v-card>
				<v-alert
					prominent
					color="grey lighten-2"
					border="bottom"
					icon="mdi-cash"
				>
					<v-row align="center">
						<v-col class="grow">
							<div class="text-h6">
								{{ $t("title.payment_confirmation") }}
							</div>
							<div>
								{{
									$t(
										"message.payment_confirmation_dialog_description"
									)
								}}
							</div>
						</v-col>
						<v-col class="shrink">
							<v-btn @click="close()">
								<v-icon left>mdi-close</v-icon>
								{{ $t("Close") }}
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>
				<v-card-text>
					<template v-if="payway">
						<v-form
							method="post"
							:action="payway.api_url"
							target="aba_webservice"
							id="aba_merchant_request"
							ref="form"
						>
							<input
								type="hidden"
								name="req_time"
								v-model="payway.req_time"
							/>
							<input
								type="hidden"
								name="merchant_id"
								v-model="payway.merchant_id"
							/>
							<input
								type="hidden"
								name="hash"
								v-model="payway.hash"
							/>
							<input
								type="hidden"
								name="tran_id"
								v-model="payway.tran_id"
							/>
							<input
								type="hidden"
								name="amount"
								v-model="payway.amount"
							/>
							<input
								type="hidden"
								name="items"
								v-model="payway.items"
							/>
							<input
								type="hidden"
								name="shipping"
								v-model="payway.shipping"
							/>
							<input
								type="hidden"
								name="firstname"
								v-model="payway.firstname"
							/>
							<input
								type="hidden"
								name="lastname"
								v-model="payway.lastname"
							/>
							<input
								type="hidden"
								name="phone"
								v-model="payway.phone"
							/>
							<input
								type="hidden"
								name="email"
								v-model="payway.email"
							/>
							<input
								type="hidden"
								name="return_params"
								v-model="payway.return_params"
							/>
							<input
								type="hidden"
								name="return_url"
								v-model="payway.return_url"
							/>
							<input
								type="hidden"
								name="payment_option"
								v-model="payway.payment_option"
							/>
						</v-form>
						<iframe
							scrolling="yes"
							class="aba-iframe"
							src=""
							name="aba_webservice"
							id="aba_webservice"
							style="width: 100%; height: 100%; min-height: 500px"
							frameBorder="0"
						></iframe>
					</template>
					<template v-else>
						<v-layout row wrap fill-height class="text-center">
							<v-flex xs12>
								<h3>{{ $t("label.please_wait") }}</h3>
							</v-flex>
						</v-layout>
					</template>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import CheckoutAddressForm from "@Shop/forms/CheckoutAddressForm.vue";
import CheckoutVoucherForm from "@Shop/forms/CheckoutVoucherForm.vue";
import CheckoutPaymentMethodForm from "@Shop/forms/CheckoutPaymentMethodForm.vue";
import Vue from "vue";
export default {
	components: {
		CheckoutAddressForm,
		CheckoutVoucherForm,
		CheckoutPaymentMethodForm,
	},

	props: ["cart", "addresses", "payment_methods", "vouchers"],

	data() {
		return {
			item: this.$inertia.form({
				cart_uuid: this.$route().params.cart_uuid,
				address_id: null,
				payment_method_code: null,
				description: null,
				hash: null,
				voucher_uuid: null,
				type: "delivery",
			}),
			dialog: false,
			payway: null,
			cart_data: this.cart,
		};
	},

	watch: {
		"item.voucher_uuid": {
			async handler() {
				if (this.item.voucher_uuid) {
					await this.applyVoucher();
				} else {
					await this.removeVoucher();
				}
			},
			immediate: false,
		},
	},

	methods: {
		async submit() {
			switch (this.item.payment_method_code) {
				case "PAYWAY":
					this.pay("cards");
					break;
				case "ABAPAY":
					this.pay("abapay");
					break;
				case "WALLET":
					await this.makeOrderWithWallet();
					break;
				default:
					this.checkout();
					break;
			}
		},

		checkout() {
			this.item.post(this.$route("shop.delivery.checkout.store"));
		},

		async makeOrderWithWallet() {
			const response = await axios.post(
				this.$route("wallet.can_pay_cart", {
					cart: this.$route().params.cart_uuid,
				})
			);

			if (response.data.success == true) {
				if (response.data.data == true) {
					this.checkout();
				}
			}
		},

		async pay(payment_option) {
			try {
				this.payway = null;
				const response = await axios.get(
					this.$route("payway.carts.checkout", {
						cart: this.cart_data.uuid,
						payment_option: payment_option,
					})
				);
				if (response.data.success == true) {
					this.dialog = true;
					this.payway = response.data.data;
					this.item.hash = this.payway.hash;
					Vue.nextTick(() => {
						document
							.getElementById("aba_merchant_request")
							.submit();
					});
				}
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		async close() {
			await this.verifyPayment();
		},

		async verifyPayment() {
			try {
				this.$wait.start("verifying payment");
				const response = await axios.post(
					this.$route("payway.orders.verify", {
						hash: this.item.hash,
					})
				);
				if (response.data.success) {
					if (response.data.data) {
						this.checkout();
					} else {
						this.$toast.open("please complete payment to continue");
					}
					this.dialog = false;
				} else {
					this.$toast.error(response.data.data);
				}
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("verifying payment");
			}
		},

		async applyVoucher() {
			try {
				this.$wait.start("applying voucher");
				const response = await axios.post(
					this.$route("shop.vouchers.apply", {
						cart: this.cart_data.uuid,
						voucher: this.item.voucher_uuid,
					})
				);
				if (response.data.success) {
					this.cart_data = response.data.data;
				}
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("applying voucher");
			}
		},

		async removeVoucher() {
			try {
				this.$wait.start("removing voucher");
				const response = await axios.post(
					this.$route("shop.vouchers.remove", {
						cart: this.cart_data.uuid,
					})
				);
				if (response.data.success) {
					this.cart_data = response.data.data;
				}
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("removing voucher");
			}
		},

		confirmLeave() {
			return window.confirm(
				"Do you really want to leave? you have unsaved changes!"
			);
		},

		confirmStayInDirtyForm() {
			return !this.confirmLeave();
		},

		beforeWindowUnload(e) {
			if (this.confirmStayInDirtyForm()) {
				e.preventDefault();
				e.returnValue = "";
			}
		},
	},

	created() {
		window.addEventListener("beforeunload", this.beforeWindowUnload);
	},

	beforeDestroy() {
		window.removeEventListener("beforeunload", this.beforeWindowUnload);
	},
};
</script>